import { createContext, useContext, useEffect } from 'react';

type SetPageActions = (actions: React.ReactNode) => void;

export const PageActionsContext = createContext<SetPageActions>(() => {});

/**
 * Returns the setter for page-level header actions.
 * Call inside a useEffect to set/clear actions when the page mounts/unmounts.
 */
export function useSetPageActions(): SetPageActions {
  return useContext(PageActionsContext);
}
